import { PageHeader } from '@ksyos/design-system';
import { useParams, useSearchParams } from '@ksyos/router';
import { ManagerAuthorization } from '@common/enums';
import { assertHasAuthorization } from '@frontend/utils';
import { getSelectedLanguage } from '../../../translate';
import { PageTemplate } from '../../templates/PageTemplate';
import { GroupCarePathsOverview } from './GroupCarepathsOverview';
import { GroupNavigation } from './GroupNavigation';
import { GroupOrganizationsOverview } from './GroupOrganizationsOverview';
import { GroupProfile } from './GroupProfile';

export enum groupSetting {
    carePaths = 'carePaths',
    details = 'details',
    inactiveCarePaths = 'inactiveCarePaths',
}

export function GroupView(): JSX.Element | null {
    assertHasAuthorization(ManagerAuthorization.groupRead);
    const { groupId } = useParams();
    const [searchParams] = useSearchParams();
    const setting = searchParams.get('setting');
    const translate = getSelectedLanguage();

    if (!groupId) {
        return null;
    }

    return (
        <>
            <PageTemplate
                sideBarNavigation={<GroupNavigation groupId={groupId} />}
                sideBarProfile={
                    <GroupProfile
                        groupId={groupId}
                        size="large"
                    />
                }
                topBarNavigation={<GroupNavigation groupId={groupId} />}
                topBarProfile={
                    <GroupProfile
                        groupId={groupId}
                        size="small"
                    />
                }
                width="small"
            >
                {!setting && (
                    <>
                        <PageHeader title={translate.groups.groupOverview} />
                        <GroupCarePathsOverview groupId={groupId} />
                        <GroupOrganizationsOverview groupId={groupId} />
                    </>
                )}
            </PageTemplate>
        </>
    );
}
